import { inject } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { ScreenUtils } from '@sc/utils';
import { map } from 'rxjs/operators';

export const MobileFitterOpeningsPageGuardCanActivate: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const route = inject(ActivatedRoute);

  const redirectUrl = '/declaration/fitter/<brandId>/<fitterId>';
  const redirectUrlBackup = '/declaration/sinister-data';

  return route.params.pipe(
    map((params) => {
      const brandId = params?.brandId;
      const fitterId = params?.fitterId;

      return ScreenUtils.isMobileResolution()
        ? true
        : router.parseUrl(
            fitterId
              ? redirectUrl
                  .replace('<brandId>', brandId)
                  .replace('<fitterId>', fitterId)
              : redirectUrlBackup
          );
    })
  );
};
